// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.avatar-me[data-v-27abbeda]:hover {\n  cursor: pointer;\n  opacity: 0.7;\n}\np.sub-title[data-v-27abbeda] {\n  color: #363636;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
